import type { AddressDTO, ContactAddressDTO } from '@invenco/common-interface/shared';

import { Skeleton } from '@/components/core/skeleton';

type Props = {
  address?: AddressDTO | ContactAddressDTO;
  isLoading?: boolean;
};

function isContactAddress(address?: AddressDTO | ContactAddressDTO): address is ContactAddressDTO {
  return Boolean(address && 'contactName' in address);
}

export function AddressDisplay({ address, isLoading }: Props) {
  if (isLoading) {
    return (
      <div className="space-y-1" aria-busy>
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    );
  }

  const location = [address?.city, address?.state, address?.postcode].filter(Boolean).join(', ');

  const contactAddress = isContactAddress(address) ? address : undefined;

  const rows = [
    address?.companyName,
    contactAddress?.contactName,
    contactAddress?.contactNumber,
    contactAddress?.contactEmail,
    address?.address1,
    address?.address2,
    location,
    address?.country,
  ].filter(Boolean);

  return (
    <div className="space-y-1 text-sm">
      {rows.map((row) => (
        <div key={row}>{row}</div>
      ))}
    </div>
  );
}
